/**
 * @flow
 * @relayHash 6882f93ee4c9aca420baedf1ca70bc11
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateStripeCheckoutSessionInput = {|
  invoiceId: string,
  customerEmail?: ?string,
|};
export type CreateStripeCheckoutSessionMutationVariables = {|
  input: CreateStripeCheckoutSessionInput
|};
export type CreateStripeCheckoutSessionMutationResponse = {|
  +createStripeCheckoutSession: {|
    +sessionUrl: string
  |}
|};
export type CreateStripeCheckoutSessionMutation = {|
  variables: CreateStripeCheckoutSessionMutationVariables,
  response: CreateStripeCheckoutSessionMutationResponse,
|};
*/


/*
mutation CreateStripeCheckoutSessionMutation(
  $input: CreateStripeCheckoutSessionInput!
) {
  createStripeCheckoutSession(input: $input) {
    sessionUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateStripeCheckoutSessionInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createStripeCheckoutSession",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateStripeCheckoutSessionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "sessionUrl",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateStripeCheckoutSessionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateStripeCheckoutSessionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateStripeCheckoutSessionMutation",
    "id": null,
    "text": "mutation CreateStripeCheckoutSessionMutation(\n  $input: CreateStripeCheckoutSessionInput!\n) {\n  createStripeCheckoutSession(input: $input) {\n    sessionUrl\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3dcd7e9c6d7e012624af559d601e85ed';
module.exports = node;
